import styled from 'styled-components';

export const Loading = styled.div`
  text-align: center;
`;

export const Error = styled.div`
  text-align: center;
`;
